import { createAction } from '@gef-ui/utils/fsaActions';
import { actionTypes } from '../constants';
/**
 *
 * @documented
 * @category Action
 * @example
 *
 * 	dispatch(setRequestStatus({ requestUuid: String, status: requestStates.COMPLETED }));
 *
 */ export const setRequestStatus = createAction(actionTypes.SET_REQUEST_STATUS);
/**
 *
 * @documented
 * @category Action
 * @example
 *
 * dispatch(clearRequestStatus(requestUuid));
 *
 */ export const clearRequestStatus = createAction(actionTypes.CLEAR_REQUEST_STATUS);
/**
 *
 * Resets whole status state
 *
 * @documented
 * @category Action
 * @example
 *
 * dispatch(reset());
 *
 */ export const reset = createAction(actionTypes.RESET);
export default {
    setRequestStatus,
    clearRequestStatus,
    reset
};
